export default function useReloadCurrentPage() {
  function reloadPage(){ 
    return window.location.reload(); 
  }
  reloadPage()
}
